import { css } from '@emotion/react';
import { Placement } from '@floating-ui/react';
import { theme } from '@frontend/theme';
import { useTooltip, Text } from '@frontend/design-system';

type EligibilityReportTooltipProps = {
  title: string;
  hoverText: string[];
  placement: Placement;
};

export const EligibilityReportTooltip = ({ title, hoverText, placement }: EligibilityReportTooltipProps) => {
  const { tooltipProps, triggerProps, Tooltip } = useTooltip({ placement });
  return (
    <>
      <Text size='medium' {...triggerProps}>
        {title}
      </Text>
      {(hoverText || []).length > 0 && (
        <Tooltip css={tooltipCSS} {...tooltipProps}>
          <ul css={unorderedListCSS}>
            {hoverText.map((text, index) => (
              <li key={index}>{text}</li>
            ))}
          </ul>
        </Tooltip>
      )}
    </>
  );
};

const tooltipCSS = css`
  white-space: pre-line;
`;
const unorderedListCSS = css`
  padding-left: ${theme.spacing(2)};
  word-break: break-word;
`;
